import { useOutletContext } from "react-router-dom";
import type { ProjectOutletContext } from "~/pages/manifold-nextgen/components/projects/ProjectLayout";

export const useProjectContext = () => useOutletContext<ProjectOutletContext>();
